const API = process.env.REACT_APP_API_END_POINT;
let options = {
  credentials: 'include',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
}
const responseJson = response => response.json();
export const fetchShifts = () => fetch(`${API}/shifts`, options).then(responseJson)
export const fetchUsers = () => fetch(`${API}/users`, options).then(responseJson)
export const fetchEvents = (eventMonth, eventYear) => fetch(`${API}/events/${eventYear}/${eventMonth}`, options).then(responseJson)
export const postEvents = (body) => fetch(`${API}/user/events`, { ...options, method: 'POST', body: JSON.stringify(body) }).then(responseJson);
export const deleteEvents = (body) => fetch(`${API}/user/events`, { ...options, method: 'DELETE', body: JSON.stringify(body) }).then(responseJson);
export const checkAuth = () => fetch(`${API}/authenticated`, options)
export const logout = () => fetch(`${API}/logout`, options).then(responseJson)